module.exports = __webpack_public_path__ + "static/media/locksmith.33d34de6.svg";